import {QuickSelectionId} from '../types'

export const KEY_TIME_RANGE = 'timeRange'
export const PLANT_STATUS_DEFAULT_TIME_RANGE = 'today'
export const LOCATION_STATUS_DEFAULT_TIME_RANGE = 'currentMonth'

/** QuickSelections for Global/Location/Area page filters */
export const LOCATION_QUICK_SELECTIONS: QuickSelectionId[] = [
  'currentMonth',
  'lastMonth',
  'yearToMonthYTM',
  'last3months',
  'yearToDateYTD',
  'lastYear'
]

/** QuickSelections for Plant page filters */
export const PLANT_QUICK_SELECTIONS: QuickSelectionId[] = [
  'today',
  'yesterday',
  'last7days',
  'currentMonth',
  'lastMonth',
  'yearToMonthYTM',
  'last3months',
  'yearToDateYTD',
  'lastYear'
]
